export const addPartnerNoteModalInitValue = {
  data: {
    text: '',
    isLoading: false,
  },
  actions: {
    handleCloseModal: () => {},
    handleChangeText: () => {},
    handleSavePartnerNote: () => {},
  },
};
